module.exports = __webpack_public_path__ + "cb07cd8ffc9632f0183a235a016c9cc4.docx";